<template>
    <div :class="['nobleLevel', isMode && 'nobleLevel-afterBox']" ref="nobleLevel">
        <div>
            <div class="nobleLevel-box">
                <Navbar class="nav-bar" :statusHeight="statusHeight"
                    :backIcon="require(`@/assets/icon_${isMode ? 'back' : 'back_white'}.png`)"
                    :background="isMode ? '#FFFFFF' : 'transparent'" :isNavtiveBack="true">
                    <template #title>
                        <span class="nobleLevel-nav-title" :style="{ color: isMode ? '#181818' : '#FFFFFF' }">{{
                            $t('贵族等级') }}</span>
                    </template>
                </Navbar>
                <div class="nobleLevel-detail px-14px">
                    <NobleList :language="language" :noble="userNoble" />
                </div>
            </div>
            <div class="noblePrivilege-box px-14px">
                <PrivilegeList :language="language" :list="nobleList" :activedId="activedId" />
            </div>
        </div>
    </div>
</template>

<script>
import { appFunc_senToken, appFunc_changeBar } from '@/utils/bridge'
import { CommonModule } from '@/store/modules/common'
import Navbar from '@/components/Navbar.vue';
import NobleList from './components/NobleList.vue';
import PrivilegeList from './components/PrivilegeList.vue';
import { getUserNobility } from '@/api'
export default {
    components: {
        Navbar,
        NobleList,
        PrivilegeList
    },
    data() {
        return {
            statusHeight: 44,
            background: 'transparent',
            isMode: false,
            nobleList: [],
            userNoble: {},
            activedId: 0
        }
    },
    watch: {
        isMode: {
            handler(val) { appFunc_changeBar({ statusBarModel: val, navBarBackground: '#110C24' }) },
            immediate: true
        }
    },
    methods: {
        getUserNoble() {
            getUserNobility().then(res => {
                if(res.code === 1001 && res.data && res.data.liveNobilityLevelConfigs) {
                    this.nobleList = res.data.liveNobilityLevelConfigs
                    let levelBgId = 0
                    const noble = this.nobleList.filter((item, index) => {
                        if(item.id === res.data.level) {
                            levelBgId = index
                            this.activedId = index
                            return item.id === res.data.level
                        }
                    })
                    this.userNoble = noble.length ? noble[0] : {}
                    this.userNoble.nextLevelDifference = res.data.nextLevelDifference || 0
                    this.userNoble.nextLevelName = res.data.nextLevelName || ''
                    this.userNoble.levelName = res.data.level == -1 ? this.$t('暂无任何') : res.data.levelName
                    this.userNoble.levelBgId = levelBgId + (res.data.level == -1 ? 0 : 1)
                    this.userNoble.value = res.data.value
                    this.userNoble.isMaxLevel = res.data.level === this.nobleList.length
                }
            })
        },
        setLanguage() {
            // 获取当前语言
            console.log('setLanguage', window.location.href)
            const data = this.$route.query.language || 'ug'
            this.language = data
            this.$i18n.locale = data
            CommonModule.setLanguage(data)
        },
        async getToken() {
            const res = await appFunc_senToken()
            this.headUrl = res.headUrl
            console.log(res, '/////////////')
            CommonModule.setUserId(res.id)
            CommonModule.setToken(res.tokenForJs)
            CommonModule.setUserPhone(res.mobile)
            CommonModule.setUserName(res.name)
        },
        resultIsmode(e) {
            this.isMode = e.target.scrollTop > 30
        }
    },
    async created() {
        this.setLanguage();
        this.statusHeight = +this.$route.query.statusBarHeight;
        await this.getToken()
        this.getUserNoble()
    },
    mounted() {
        this.$refs['nobleLevel'].addEventListener('scroll', this.resultIsmode)
    },
    beforeDestroy() {
        this.$refs['nobleLevel'].removeEventListener('scroll', this.resultIsmode)
    },
}
</script>

<style lang="scss" scoped>
.nobleLevel {
    display: flex;
    flex-direction: column;
    width: 100vw;
    height: 100vh;
    overflow-y: scroll;
    background-color: #110C24;

    &::after {
        content: '';
        position: absolute;
        width: 100%;
        height: 244px;
        background: url('../../assets/noble/noble-container-bg.png') no-repeat;
        background-size: contain;
        transition: all .3s ease-in-out;
    }

    &::-webkit-scrollbar {
        display: none;
    }

    .nobleLevel-box {
        .nobleLevel-nav-title {
            font-weight: 500;
            font-size: 18px;
            color: #FFFFFF;
        }

        .nav-bar {
            display: block;
            position: fixed;
            width: 100vw;
            box-sizing: border-box;
            z-index: 999;
            padding: 0;
        }

        .nobleLevel-detail {
            width: 100%;
            padding-top: 68px;
        }
    }

    .noblePrivilege-box {
        flex: 1;
        overflow-y: hidden;
        padding-top: 32px;
        padding-bottom: 24px;
    }
}

.nobleLevel-afterBox::after {
    height: 0;
}

.px-14px {
    padding: 0 14px;
    box-sizing: border-box;
}
</style>